import { Point } from "../../graphicLibs/index";
import { PointInfo } from "../../WalltoFittingInfo";
import { CreatePointData } from "../CreatePointData";
import { WallGrid } from "../WallGrid";
import { OverlapWall } from "./OverlapWall";

/**
 * 部屋囲みを見て、直線状の不要な点は削除
 * 
 * 直線化して中点を削除
 * ↓
 * 重なっている壁の削除を行う
 * 
 * (隣通しの部屋で直線上の点の削除を行った場合、辺が2重でできてしまうため)
 * */
export class StraightLineDeletePoint extends WallGrid {

    constructor(public pointList: PointInfo[]) {
        super(pointList);
    }

    public execute(): PointInfo[] {
        
        const pointData = new CreatePointData(this.pointList);
        pointData.execute();
        const roomList = pointData.roomList;
        
        /**  他の頂点も入っていたら */
        const search = (roomIndex: number, pointIndex: number): boolean => {
            const gridList = this.indexToGridList[roomList[roomIndex][pointIndex]];
            const nextGridList = this.indexToGridList[Point.nextPoint(roomList[roomIndex][pointIndex])];
            return (3 <= this.clockwiseData[gridList].length || 3 <= this.clockwiseData[nextGridList].length);
        }

        for (let i = 0; i < roomList.length; i++) {
            let deleteList: number[] = [];
            for (let j = 0; j < roomList[i].length; j++) {

                const i1 = roomList[i][j];
                const i2 = roomList[i][(j + 1) % roomList[i].length];
                const i3 = roomList[i][(j + 2) % roomList[i].length];

                const p1 = this.pointList[i1].point;
                const p2 = this.pointList[i2].point;
                const p3 = this.pointList[i3].point;

                /** 80度から90度までは除外 */
                const sin = p1.clone().sub(p2).clone().normalize().cross(p3.clone().sub(p2).clone().normalize()).y;
                if ((0.9848 <= sin && sin <= 1) || (-1 <= sin && sin <= -0.9848)) continue;

                const dir = p2.clone().sub(p1);
                const next = p3.clone().sub(p1);
                const length = dir.clone().dot(next) / (next.length());
                /** 垂直に下したときの線が線分上になかったら除外 */
                if (next.length() < length || length < 0) continue;
                
                const line = dir.clone().cross(next).divideScalar(next.length());
                /** 直線上の点の削除 */
                if (line.length() < this.e) {
                    /** 他の部屋の頂点が存在していたら削除しない */
                    if (search(i, (j + 1) % roomList[i].length) == true) continue;
                    deleteList.push((j + 1) % roomList[i].length);
                }

            }

            if (deleteList.length == 0) continue;

            let isDelete = false;
            for (let j = 0; j < roomList[i].length; j++) {
                if (isDelete == false && deleteList.includes(j) == true) {
                    isDelete = true;
                    deleteList = deleteList.filter((index: number) => index != j);
                    const beforeIndex = (j - 1 + roomList[i].length) % roomList[i].length;
                    this.pointList[roomList[i][beforeIndex]].isDelete = true;
                    this.pointList[Point.nextPoint(roomList[i][beforeIndex])].isDelete = true;
                    this.pointList[roomList[i][j]].isDelete = true;
                    this.pointList[Point.nextPoint(roomList[i][j])].isDelete = true;
                    const info: PointInfo = {
                        point: this.pointList[roomList[i][beforeIndex]].point.clone(),
                        isDelete: false,
                        isExist: true
                    };
                    this.pointList.push(info);
                } else if (isDelete == true && deleteList.includes(j) == true) {
                    deleteList = deleteList.filter((index: number) => index != j);
                    this.pointList[roomList[i][j]].isDelete = true;
                    this.pointList[Point.nextPoint(roomList[i][j])].isDelete = true;
                } else if ((isDelete == true && deleteList.includes(j) == false)) {
                    const info: PointInfo = {
                        point: this.pointList[roomList[i][(j + 1) % roomList[i].length]].point.clone(),
                        isDelete: false,
                        isExist: true
                    };
                    this.pointList.push(info);
                    isDelete = false;
                }

                if ((isDelete == true && deleteList.length == 0)) {
                    const info: PointInfo = {
                        point: this.pointList[roomList[i][(j + 1) % roomList[i].length]].point.clone(),
                        isDelete: false,
                        isExist: true
                    };
                    this.pointList.push(info);
                    isDelete = false;
                }
            }
        }

        return new OverlapWall(this.pointList).execute();
    
    }

    public length(e: number) {
        this.e = e / 1000; /** 単位 mm → m */
    }

}